export class WorkerApiClient {
  constructor(baseUrl = 'http://127.0.0.1:8787') {
    this.baseUrl = baseUrl.replace(/\/$/, '');
  }

  setBaseUrl(newUrl) {
    this.baseUrl = newUrl.replace(/\/$/, '');
  }

  async checkHealth() {
    try {
      const response = await fetch(`${this.baseUrl}/api/health`, { method: 'GET' });
      if (!response.ok) return { online: false };
      const data = await response.json();
      return { online: true, data };
    } catch (err) {
      return { online: false, error: err.message };
    }
  }

  async searchByCurp(curp) {
    const sanitizedCurp = encodeURIComponent(curp.trim().toUpperCase());
    const endpoint = `${this.baseUrl}/api/buscar?curp=${sanitizedCurp}`;

    try {
      const response = await fetch(endpoint, {
        method: 'GET',
        headers: {
          'Accept': 'application/json'
        }
      });

      const body = await response.json();

      if (response.status === 200 && body.success) {
        return {
          found: true,
          status: 200,
          data: body.data
        };
      } else if (response.status === 404) {
        return {
          found: false,
          status: 404,
          message: body.message || 'No se encontró el registro para esta CURP.'
        };
      } else {
        return {
          found: false,
          status: response.status,
          error: body.error || body.message || 'Error al consultar la API.'
        };
      }
    } catch (error) {
      return {
        found: false,
        status: 500,
        error: `No se pudo conectar con el servidor Worker (${this.baseUrl}). Asegúrese de que esté en ejecución.`
      };
    }
  }
}
